// extracted by mini-css-extract-plugin
module.exports = {"trigger":"toggleFoilButton_trigger__MNcdB","optionsMenu":"toggleFoilButton_optionsMenu__VL9A8"};